@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.top {
  background: @scan-page--verify-scan-warning-modal-top--background-color;
  height: 200px;
  display: flex;
  justify-content: center;
}

.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 150px;
  font-size: 24px;
  padding: 20px;
}

.bottom-buttons {
  display: flex;
  width: 100%;
  justify-content: center;
}

.warning-symbol {
  fill: @scan-page--verify-scan-warning-modal--fill-color;
  height: 175%;
  width: 175%;
  position: relative;
  bottom: 37.5px;
  right: 37.5px;
}

.warning-wrapper {
  background-color: @scan-page--verify-scan-warning-modal-wrapper--background-color;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  position: relative;
  top: 50px;
}

.continue-button {
  font-size: 16px;
  height: 35px;
}

.search-button {
  font-size: 16px;
  width: 165px;
  height: 35px;
  margin-left: 40px;
}

.subtext {
  color: @scan-page--verify-scan-warning-modal--text-color;
  font-size: 14px;
}
